<template>
  <section id="main-wrap" class="pure-g">  
    <div id="main-col" class="pure-u-3-5">
      <Grape v-for="grape in grapes" :grapeInstance="grape" :key="grape.id" :single="true" /> 
    </div>
  </section>
</template>

<script>
  /* global $ */
  import db from './firebaseInit'
  import Grape from './Grape.vue'
  export default {
    name: 'view-grape',
    data () {
      return {
        grapes: [],
        title: null,
        image: null,
        id: null,
        description: null,
        createdTimestamp: null,
        updatedTimestamp: null,
        grapesDatabase: this.$globals.grapesDatabase,
        isPress: this.$globals.isPress
      }
    },
    metaInfo () {
      return {
        title: this.title,
        meta: [
          { name: 'description', content: this.description },
          { itemprop: 'name', content: this.title },
          { itemprop: 'description', content: this.description },
          { itemprop: 'image', content: this.image },
          { name: 'twitter:card', content: 'summary' },
          { name: 'twitter:site', content: '@grapevine' },
          { name: 'twitter:title', content: this.title },
          { name: 'twitter:description', content: this.description },
          { name: 'twitter:image:src', content: this.image },
          { vmid: 'og:title', property: 'og:title', content: this.title },
          { vmid: 'og:type', property: 'og:title', content: 'article' },
          { vmid: 'og:url', property: 'og:url', content: 'https://atgrapevine.com/%23/view-grape/' + this.id },
          { vmid: 'og:image', property: 'og:image', content: this.image },
          { vmid: 'og:description', property: 'og:description', content: this.description },
          { vmid: 'og:site_name', property: 'og:site_name', content: 'Grapevine' },
          { vmid: 'article:published_time', property: 'article:published_time', content: this.createdTimestamp },
          { vmid: 'article:modified_time', property: 'article:modified_time', content: this.updatedTimestamp }
        ]
      }
    },
    created () {
      var vm = this
      this.fetchData()
    },
    watch: {
      '$route': 'fetchData'
    },
    methods: {
      fetchData () {
        $('body').addClass('pace-running')
        $('.pace').addClass('pace-active')
        this.grapes = []
        db.collection(this.grapesDatabase).where('id', '==', this.$route.params.grapeID).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            console.log(doc.id, ' => ', doc.data())
            var grapeData = doc.data()
            grapeData.docID = doc.id
            this.grapes.push(grapeData)
            this.title = grapeData.grapeTitle
            this.image = grapeData.sourceImage
            this.id = grapeData.id
            this.description = grapeData.grapeContent
            this.createdTimestamp = grapeData.createdTimestamp
            this.updatedTimestamp = grapeData.updatedTimestamp

            console.log(this.description)
            this.description = this.description.length > 155 ? this.description.substring(0, 150) + '...' : this.description

            $('body').removeClass('pace-running')
            $('.pace').removeClass('pace-active')
          })
        })
      }
    },
    components: {
      Grape
    }
  };
</script>

<style scoped>
  #main-wrap {
    background: #f9f9f9;
    min-height: 100vh;
  }
  h1 {
    font-size: 30px;
    margin: 30px 0;
  }
  p {
    margin-bottom: 20px;
  }
  .contact--section {
    background-color: white;
    padding: 20px;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.05);
    .__name {
      font-size: 30px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/ViewGrape.vue